import Layout from '@/layout';
var invoiceRouter = {
  path: '/invoice',
  component: Layout,
  redirect: '/invoice/index',
  name: 'Invoice',
  alwaysShow: true,
  meta: {
    title: '发票',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/invoice/index');
    },
    name: 'InvoiceIndex',
    meta: {
      title: '发票管理'
    }
  }]
};
export default invoiceRouter;